<template>
  <div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column type="index" :index="indexMethod">
      </el-table-column>
      <el-table-column prop="trade_type" label="类型" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="card_id" label="充值卡号" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
            <span v-if="scope.row.card_id">
              {{scope.row.card_id}}
            </span>
        </template>
      </el-table-column>
      <el-table-column prop="total" label="充值金额" width="80">
      </el-table-column>
      <el-table-column prop="days" label="有效期" width="70">
      </el-table-column>
      <el-table-column prop="add_time" label="购买时间" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.state===0&&scope.row.total/scope.row.desc>100&& new Date(scope.row.add_time) > new Date('2020-07-21 00:00:00') && parseInt(new Date() - new Date(scope.row.add_time)) < 2592000000"
            plain
            size="mini"
            type="primary"
            @click="select_invoice(scope.row)">申请发票
          </el-button>
          <!--          @click="apply_invoice(scope.$index, scope.row)">申请发票-->
          <el-button
            v-else-if="scope.row.state ===1 "
            plain
            size="mini"
            type="info"
            @click="apply_invoice_ing(scope.$index, scope.row)">申请中
          </el-button>
          <span v-else-if="scope.row.state ===2 ">
            <el-button
              v-if="scope.row.type ===1"
              plain
              size="mini"
              type="danger"
              @click="apply_invoice_download(scope.$index, scope.row)">下载发票
            </el-button>
            <el-popover
              v-else
              placement="top"
              title="快递信息"
              width="200"
              trigger="click">
                <span>快递公司:{{content.company}}</span>
                <br>
                <span>快递单号司:{{content.code}}</span>
                <el-button
                  plain
                  size="mini"
                  type="danger"
                  @click="viewText(scope.$index, scope.row)" slot="reference">查看单号
                </el-button>
              </el-popover>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="申请发票"
      :visible.sync="dialogVisible"
      width="450px"
      :before-close="handleClose">
      <div class="invoice_data">
        <p>公司名称：{{invoice_data.company_name}}</p>
        <p>纳税人识别号：{{invoice_data.duty_paragraph}}</p>
        <p>地址及电话：{{invoice_data.site_phone}}</p>
        <p>开户行及账号：{{invoice_data.bank}}</p>
        <p>邮寄发票-收件人：{{invoice_data.name}}</p>
        <p>邮寄发票-地址：{{invoice_data.address}}</p>
        <p>邮寄发票-电话：{{invoice_data.phone}}</p>
        <p class="hint">*请保证以上信息正确无误，如信息错误造成损失自行承担*</p>
        <p class="click_me" @click="click_me">&gt;&gt;点我编辑开票信息&lt;&lt;</p>
      </div>
      <p style="margin-bottom:10px;font-size:16px">请选择开票内容:</p>
      <p style="margin-bottom:20px">
          <el-radio-group v-model="contents">
            <el-radio label="文献信息检索费">文献信息检索费</el-radio><br>
            <el-radio label="数据库服务费">数据库服务费</el-radio>><br>
            <el-radio label="其他请咨询客服微信：mylibs">其他请咨询客服微信：mysql365</el-radio>
          </el-radio-group>
        </p>
      <p style="margin-bottom:10px;font-size:16px">请选择开票方式:</p>
      <el-button type="success" plain @click="method_invoice(1)" :disabled="!d" :title="!d?'当前不能申请电子发票':''">电子发票</el-button>
      <el-button type="primary" plain @click="method_invoice(0)" :disabled="!z" :title="!z?'当前不能申请纸质发票':''">纸质发票</el-button>
    </el-dialog>
  </div>
</template>

<script>
  import download from 'ly-downloader'
  import qs from 'qs'

  export default {
    data() {
      return {
        tableData: [],
        dialogVisible: false,
        // 被选中的id
        selected: '',
        content: {
          company: '',
          code: ''
        },
        z: '',
        d: '',
        invoice_data: {
          company_name: "",
          duty_paragraph: "",
          site_phone: "",
          bank: "",
          email: "",
          name: "",
          address: "",
          phone: ""
        },
        contents: ''
      }
    },
    created() {
      this.$parent.$el.firstElementChild.className = "grouping grouping2"
      // 获取当前用户的财务记录
      this.get_data()
    },
    destroyed() {
      this.$parent.$el.firstElementChild.className = "grouping"
    },
    methods: {
      async select_invoice(row) {
        // 申请发票之前，先读取能够申请哪些类型的发票
        await this.$http.getInvoiceProvide().then(res => {
          if (res.code === 200) {
            this.d = res.data.d
            this.z = res.data.z
            this.dialogVisible = true
            this.selected = row
          }
        }).catch(err => {
          console.log(err, 'err')
        })
      },
      async request_invoice () {
        this.$http.getInvoiceData().then(response => {
            if (response.code == 200) {
              this.invoice_data.company_name = response.data.company;
              this.invoice_data.duty_paragraph = response.data.code;
              this.invoice_data.site_phone = response.data.addr_tel;
              this.invoice_data.bank = response.data.acount;
              this.invoice_data.email = response.data.receive_email;
              this.invoice_data.name = response.data.receive_user;
              this.invoice_data.address = response.data.receive_addr;
              this.invoice_data.phone = response.data.receive_phone;
            }
        })
      },
      handleClose() {
        this.dialogVisible = false
      },
      method_invoice(flag) {
        if (!this.contents) {
          return this.$message({
                  message: '请选择开票内容',
                  center: true,
                  type: 'warning',
                  customClass: 'hint-message'
                })
        }
        this.dialogVisible = false
        // 发送请求
        this.apply_invoice(this.selected, flag)
      },
      indexMethod(index) {
        return index + 1;
      },
      get_data() {
        this.$http.getUserFinancial().then(res => {
          if (res.code === 200) {
            this.tableData = res.data
          }
        }).catch(err => {
          console.log(err, 'err')
        })
      },
      apply_invoice(r, flag) {
        let data = {'o_id': r.id, 'flag': flag, 'content': this.contents} // flag:0 纸质 1:电子
        this.$http.postApplyInvoice(qs.stringify(data)).then(res => {
          if (res.code === 200) {
            this.$message.success('申请成功,在1-3个工作日内，可进行发票下载！')
            r.state = 1
          } else if (res.code === 400) {
            //当前用户还没有填写发票信息
            this.$message.error('请先在发票信息管理栏目中填写发票信息！再进行发票申请！')
          }
        }).catch(err => {
          console.log(err, 'err')
        })
      },
      apply_invoice_ing() {
        this.$message.info('正在申请中，请等待！')
      },
      apply_invoice_download(i, d) {
        this.$message.success('下载发票')
        download(1, `/api/operation/download_invoice/?id=${this.url_encode(d.id)}`, `${d.id}.pdf`)
      },
      viewText(index, row) {
        this.content = row.data
      },
      url_encode(sStr) {
        return escape(sStr).replace(/\+/g, '%2B').replace(/\"/g, '%22').replace(/\'/g, '%27').replace(/\//g, '%2F');
      },
      click_me () {
        this.dialogVisible = false
        setTimeout(()=>{
          this.$emit('switchover', "invoice_information")
        }, 100)
      }
    },
    watch:{
      dialogVisible () {
        if (this.dialogVisible) {
          this.request_invoice()
        }else{
          this.invoice_data = {
            company_name: "",
            duty_paragraph: "",
            site_phone: "",
            bank: "",
            email: "",
            name: "",
            address: "",
            phone: ""
          }
        }
      }
    }
  };
</script>
<style scoped>
.invoice_data {
  border: 1px solid #aaa;
  padding: 10px;
  margin-bottom: 20px;
}
.hint {
  color: red;
}
.click_me {
  color: #04AFEF;
  cursor: pointer;
}
.click_me:hover {
  color: #0088cc;
}
</style>
